import {
  GET_COLLABORATION_FOLDERS,
  GET_COLLABORATION_FOLDERS_CHANGED,
} from "./actions.type";
import {
  SET_COLLABORATION_FOLDERS,
  SET_COLLABORATION_FOLDERS_CHANGED,
} from "./mutations.type";

import { getFolders } from "@/services/collaboration/folders.service";

const STATE = {
  folders: null,
  foldersChange: true,
};

const GETTERS = {
  folders: (state) => state.folders,
  foldersChange: (state) => state.foldersChange,
};

const ACTIONS = {
  async [GET_COLLABORATION_FOLDERS](context, data) {
    let folders = context.state.folders;
    if (context.state.foldersChange || (data && data.force)) {
      folders = await getFolders();
      context.commit(SET_COLLABORATION_FOLDERS_CHANGED, false);
    }
    context.commit(SET_COLLABORATION_FOLDERS, folders);
    return Promise.resolve(true);
  },
  async [GET_COLLABORATION_FOLDERS_CHANGED](context, data) {
    context.commit(SET_COLLABORATION_FOLDERS_CHANGED, data);
    return Promise.resolve(true);
  },
};

const MUTATIONS = {
  [SET_COLLABORATION_FOLDERS](state, data) {
    state.folders = data;
  },
  [SET_COLLABORATION_FOLDERS_CHANGED](state, data) {
    state.foldersChange = data;
  },
};

export default {
  namespaced: true,
  state: STATE,
  actions: ACTIONS,
  mutations: MUTATIONS,
  getters: GETTERS,
};
